import { apiClient, type RequestOptions } from '@/services/apiClient';
import type { SecurityCommandCenter } from './security.types';

export const securityApi = {
  getDashboard: (options?: RequestOptions) => apiClient.get<SecurityCommandCenter>('/v1/security/command-center', options),
  runScan: (_input: void, options?: RequestOptions) => apiClient.post<SecurityCommandCenter['scans'][number]>('/v1/security/scan', {}, options),
};
